<sm-spinner [loading]="loading"></sm-spinner>
<div class="my-5">
  <!-- page-header -->
  <sm-page-header [breadcrumb]="breadcrumb" title="Activités récentes" description="Cette page présente les activités récentes de la plateforme">
  </sm-page-header>
  <!-- page-content -->
  <div class="content flex flex-col gap-5">
    <div>
      <p-select
        [options]="types"
        optionLabel="name"
        dataKey="code"
        appendTo="body"
        placeholder="Choisir un type"
        class="w-full md:w-fit"
        [ngModel]="selectedType"
        (ngModelChange)="onSelectChange($event)" />
    </div>
    <sm-data-table-builder [dataTableObject]="dataTableObject" [datas]="data?.tasks || []"></sm-data-table-builder>
  </div>
</div>
